"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var shopCarOrderApi = _interopRequireWildcard(require("@/api/shopCarOrderApi"));
var _CardStatusChangeRecords = _interopRequireDefault(require("./CardStatusChangeRecords.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var FROZEN_VALUES = [2, '2', true, 'true', '冻结中', 'FROZEN', 'frozen'];
var _default = exports.default = {
  name: 'ShopCarCardOrderDetail',
  components: {
    CardStatusChangeRecords: _CardStatusChangeRecords.default
  },
  data: function data() {
    return {
      visible: false,
      loading: false,
      detail: {},
      beansDialogVisible: false,
      editPlateNoVisible: false,
      editPlateNoLoading: false,
      editPlateNoForm: {
        oldPlateNo: '',
        plateNo: '',
        orderNo: '',
        id: ''
      }
    };
  },
  computed: {
    goodsListData: function goodsListData() {
      // 构造商品列表数据，如果没有明细则使用订单主信息
      if (this.detail.productName) {
        return [{
          productName: this.detail.productName || '--',
          unitPrice: this.detail.unitPrice || 0,
          quantity: this.detail.quantity || 0,
          totalPrice: this.detail.totalPrice || 0,
          orderStatusName: this.detail.orderStatusName || '--'
        }];
      }
      return [];
    },
    cardStatusText: function cardStatusText() {
      var named = this.detail.cardStatusName || this.detail.monthlyCardStatusName;
      if (named) return named;
      var mapped = this.mapCardStatus(this.detail.cardStatus);
      if (mapped) return mapped;
      var start = this.parseTime(this.detail.validStartTime);
      var end = this.parseTime(this.detail.validEndTime);
      var now = Date.now();
      if (start != null && now < start) return '未生效';
      if (end != null && now > end) return '已过期';
      if (start != null || end != null) return '已生效';
      return '--';
    },
    freezeStatusText: function freezeStatusText() {
      var named = this.detail.freezeStatusName;
      if (named) return named;
      if (FROZEN_VALUES.includes(this.detail.freezeStatus) || FROZEN_VALUES.includes(this.detail.freezeFlag) || FROZEN_VALUES.includes(this.detail.isFreeze)) {
        return '冻结中';
      }
      var statusName = this.detail.cardStatusName || '';
      if (String(statusName).includes('冻结')) return '冻结中';
      var start = this.parseTime(this.detail.freezeStartTime || this.detail.freezeStart);
      var end = this.parseTime(this.detail.freezeEndTime || this.detail.freezeEnd);
      if (start == null && end == null) return '--';
      var now = Date.now();
      if (start != null && end != null && now >= start && now <= end) return '冻结中';
      return '已结束';
    },
    statusChangeRecords: function statusChangeRecords() {
      return Array.isArray(this.detail.cardOperationRecords) ? this.detail.cardOperationRecords : [];
    }
  },
  methods: {
    open: function open(orderNo, row) {
      var _this = this;
      if (!orderNo) {
        this.$message.warning('订单编号缺失');
        return;
      }
      this.visible = true;
      this.loading = true;
      this.detail = {};
      this.beansDialogVisible = false;
      shopCarOrderApi.getParkingCardOrderDetail(orderNo).then(function (res) {
        _this.detail = res || {};
      }).finally(function () {
        _this.loading = false;
      });
    },
    handleClose: function handleClose() {
      this.visible = false;
      this.detail = {};
      this.beansDialogVisible = false;
    },
    handleViewBeans: function handleViewBeans() {
      this.beansDialogVisible = true;
    },
    handleViewPromotion: function handleViewPromotion() {
      this.$message.info('请在优惠记录中查看详情');
    },
    getOrderStatusType: function getOrderStatusType(statusName) {
      if (!statusName) return '';
      var status = statusName.toLowerCase();
      if (status.includes('成功') || status.includes('完成') || status.includes('已支付')) {
        return 'success';
      }
      if (status.includes('待') || status.includes('处理中')) {
        return 'warning';
      }
      if (status.includes('失败') || status.includes('取消') || status.includes('关闭')) {
        return 'info';
      }
      if (status.includes('退款')) {
        return 'danger';
      }
      return '';
    },
    parseTime: function parseTime(val) {
      if (!val) return null;
      var t = new Date(String(val).replace(/-/g, '/').replace('T', ' ')).getTime();
      return Number.isNaN(t) ? null : t;
    },
    mapCardStatus: function mapCardStatus(status) {
      if (status === 0 || status === '0' || status === '未生效') return '未生效';
      if (status === 1 || status === '1' || status === '已生效') return '已生效';
      if (status === 2 || status === '2' || status === '已过期') return '已过期';
      return '';
    },
    getCardStatusType: function getCardStatusType(statusText) {
      if (statusText === '已生效') return 'success';
      if (statusText === '未生效') return 'info';
      if (statusText === '已过期') return 'warning';
      return '';
    },
    getFreezeStatusType: function getFreezeStatusType(statusText) {
      if (statusText === '冻结中') return 'warning';
      if (statusText === '已结束') return 'info';
      return '';
    },
    openEditPlateNo: function openEditPlateNo() {
      var _this2 = this;
      if (!this.detail || !this.detail.orderNo) {
        this.$message.warning('订单编号缺失');
        return;
      }
      if (!this.detail.thirdOrderInformation || !this.detail.thirdOrderInformation.id) {
        this.$message.warning('订单信息不完整，缺少id');
        return;
      }
      this.editPlateNoForm = {
        oldPlateNo: this.detail.thirdOrderInformation.plateNo || this.detail.plateNo || '',
        plateNo: '',
        orderNo: this.detail.orderNo,
        id: this.detail.thirdOrderInformation.id
      };
      this.editPlateNoVisible = true;
      // 清除表单验证
      this.$nextTick(function () {
        if (_this2.$refs.editPlateNoForm) {
          _this2.$refs.editPlateNoForm.clearValidate();
        }
      });
    },
    handleSubmitEditPlateNo: function handleSubmitEditPlateNo() {
      var _this3 = this;
      this.$refs.editPlateNoForm.validate(function (valid) {
        if (!valid) return;
        if (!_this3.editPlateNoForm.plateNo || _this3.editPlateNoForm.plateNo.trim() === '') {
          _this3.$message.warning('请输入新车牌号');
          return;
        }
        _this3.editPlateNoLoading = true;
        shopCarOrderApi.updateParkingCardPlateNo({
          plateNo: _this3.editPlateNoForm.plateNo.trim(),
          orderNo: _this3.editPlateNoForm.orderNo,
          id: _this3.editPlateNoForm.id
        }).then(function () {
          _this3.$message.success('车牌号更新成功');
          _this3.editPlateNoVisible = false;
          // 刷新详情数据
          _this3.loading = true;
          shopCarOrderApi.getParkingCardOrderDetail(_this3.detail.orderNo).then(function (res) {
            _this3.detail = res;
          }).catch(function (err) {
            console.error('获取订单详情失败:', err);
            _this3.$message.error(err && err.message || '获取订单详情失败');
          }).finally(function () {
            _this3.loading = false;
          });
        }).catch(function () {
          // 错误信息已在 request 拦截器中处理
        }).finally(function () {
          _this3.editPlateNoLoading = false;
        });
      });
    }
  }
};